interface KeyPressEvent {
  key: string;
}

type CallbackFunction = () => void;

export const buildHandleEnterKeyPress =
  (callback: CallbackFunction | undefined) =>
  ({key}: KeyPressEvent) => {
    if (key === 'Enter') {
      callback?.();
    }
  };
